import React from 'react';
import styled from 'styled-components';
import Footer from '../components/Footer';

const Container = styled.div`
  background: #ffffff;
  min-height: 100vh;
`;

const HeroSection = styled.section`
  background: linear-gradient(135deg, #2d5a27 0%, #1a3518 100%);
  color: white;
  padding: 48px 16px;
  text-align: center;
`;

const HeroContent = styled.div`
  max-width: 700px;
  margin: 0 auto;
`;

const PageTitle = styled.h1`
  font-size: 1.75rem;
  font-weight: 700;
  margin: 0 0 12px 0;
  letter-spacing: -0.02em;

  @media (min-width: 768px) {
    font-size: 2rem;
  }
`;

const PageSubtitle = styled.p`
  font-size: 0.95rem;
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.5;
  margin: 0;
`;

const ContentSection = styled.section`
  padding: 48px 16px;
  max-width: 900px;
  margin: 0 auto;

  @media (min-width: 768px) {
    padding: 64px 24px;
  }
`;

const ContactGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 24px;
  margin-bottom: 48px;
`;

const ContactCard = styled.div`
  background: #f8f9fa;
  padding: 28px 24px;
  border-radius: 8px;
  text-align: center;
  border: 1px solid #e5e5e5;
`;

const ContactIcon = styled.div`
  width: 48px;
  height: 48px;
  background: #2d5a27;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.9rem;
  font-weight: 700;
  margin: 0 auto 16px auto;
`;

const ContactTitle = styled.h3`
  font-size: 1rem;
  font-weight: 600;
  margin: 0 0 12px 0;
  color: #1a1a2e;
`;

const ContactInfo = styled.div`
  font-size: 0.85rem;
  line-height: 1.6;
  color: #555;

  p {
    margin: 0 0 8px 0;
  }

  a {
    color: #2d5a27;
    text-decoration: none;
    font-weight: 600;

    &:hover {
      text-decoration: underline;
    }
  }
`;

const SupportSection = styled.div`
  background: #f8f9fa;
  border-radius: 8px;
  padding: 32px 24px;
  text-align: center;
`;

const SupportTitle = styled.h3`
  font-size: 1.1rem;
  font-weight: 600;
  margin: 0 0 16px 0;
  color: #1a1a2e;
`;

const SupportInfo = styled.div`
  font-size: 0.85rem;
  line-height: 1.7;
  color: #555;
  max-width: 500px;
  margin: 0 auto;

  p {
    margin: 0 0 12px 0;

    &:last-child {
      margin-bottom: 0;
    }
  }

  a {
    color: #2d5a27;
    text-decoration: none;
    font-weight: 600;

    &:hover {
      text-decoration: underline;
    }
  }
`;

const Contact = () => {
  return (
    <Container>
      <HeroSection>
        <HeroContent>
          <PageTitle>Contact Us</PageTitle>
          <PageSubtitle>
            Have questions about ShowingBooker? We're here to help you streamline
            your showing management and compliance.
          </PageSubtitle>
        </HeroContent>
      </HeroSection>

      <ContentSection>
        <ContactGrid>
          <ContactCard>
            <ContactIcon>@</ContactIcon>
            <ContactTitle>Email</ContactTitle>
            <ContactInfo>
              <p>General inquiries and support:</p>
              <p><a href="mailto:david@codexdeus.com">david@codexdeus.com</a></p>
              <p>We respond within 24 hours.</p>
            </ContactInfo>
          </ContactCard>

          <ContactCard>
            <ContactIcon>HQ</ContactIcon>
            <ContactTitle>Address</ContactTitle>
            <ContactInfo>
              <p><strong>ShowingBooker LLC</strong></p>
              <p>26565 Agoura Road, Suite 200</p>
              <p>Calabasas, CA 91302</p>
            </ContactInfo>
          </ContactCard>

          <ContactCard>
            <ContactIcon>SB</ContactIcon>
            <ContactTitle>Company</ContactTitle>
            <ContactInfo>
              <p>ShowingBooker is developed by</p>
              <p><a href="https://codexdeus.com" target="_blank" rel="noopener noreferrer">CodexDeus</a></p>
              <p>Los Angeles, California</p>
            </ContactInfo>
          </ContactCard>
        </ContactGrid>

        <SupportSection>
          <SupportTitle>Support & Response Times</SupportTitle>
          <SupportInfo>
            <p>
              <strong>Email Support:</strong> Available 24/7 with responses within 24 hours during business days.
            </p>
            <p>
              <strong>Priority Support:</strong> Available for urgent issues affecting active showings.
            </p>
            <p>
              We're committed to helping you succeed with ShowingBooker.
              Your compliance and showing management can't wait.
            </p>
          </SupportInfo>
        </SupportSection>
      </ContentSection>

      <Footer />
    </Container>
  );
};

export default Contact;
